import { Project } from '../../app/resources/project/project.interface';

(function () {
  angular.module('specsguardApp')
    .factory('ProjectDataservice', ProjectDataservice);

  ProjectDataservice.$inject = ['Project', '$rootScope', '$document', '$mdToast', 'errorMessageService',
    'ProjectInitializerService', 'sg2ProjectService', 'sg2RouterService'];

  /**
   * Project data service.
   * @legacy
   *
   * @note sg2RouterService is injected purely to initialize. Setup is done in its constructor.
   * It acts as a bridge for migration. See class docs. Do not remove dependency.
   */
  function ProjectDataservice (ProjectAPI, $rootScope, $document, $mdToast, errorMessageService,
    projectInitializerService, sg2ProjectService, sg2RouterService) {

    let projects = {};
    let projectList = [];

    const dataService = {
      getProjectList: () => {

        // There was a bug where sometimes only one project was shown when going back to
        // ProjectList page. Resolved by just calling the API everytime a user is going
        // the list page. Should not impact performance that much.
        // if (projectList.length > 0) {
        //   return Promise.resolve(projectList.slice(0));
        // }
        return ProjectAPI.query().$promise.then((list) => {
          projectList = list;
          return Promise.resolve(projectList.slice(0));
        });
      },
      getProjectById: (projectId, refresh: boolean) => {

        if (!refresh && projects[projectId.toString()]) {

          // Note: Gets called three times during info-page loading (!)
          //  1. TeamService needs it for init > Add 'getProject' to new Api, and return once.
          //  2. Sg-Navigation calls it (for some reason) > Don't kow how to solve.
          //  3. Route-resolver (This should be the only allowed call!!).
          // Result: ProjectService.set() is called multiple times for no reason, performance.
          // Checked with console.trace().

          /** @depcricated ProjectStore. */
          projectInitializerService.load(projects[projectId]);
          /** Update project Service. */
          sg2ProjectService.set(projects[projectId], true);

          return Promise.resolve(projects[projectId]);
        }

        return ProjectAPI.get({id: projectId}).$promise.then((project: Project) => {

          /** @depcricated ProjectStore. */
          projectInitializerService.load(project);
          /** Update project Service. */
          // sg2ProjectService.set(Object.assign({}, project), true);
          // sg2ProjectService.set(JSON.parse(JSON.stringify(project)), true);

          // Note: The same project is set to both the store and the $scope.
          //  Some properties 'magically' appeared, but that's because after populating the
          //  store, there is still a reference with $scope! If the $scope adds properties,
          //  the store inherits those too.
          sg2ProjectService.set(project, true);

          projects[projectId.toString()] = project;

          const toast = $document.find('md-toast');

          if (toast[0]) {
            const text = toast[0].textContent.trim();
            Object.keys(errorMessageService.errorMessages).forEach((key) => {
              if (key.includes('Updated') && errorMessageService.errorMessages[key] === text) {
                $mdToast.hide()
                  .then(() => errorMessageService.showWarning('projectRenewed'));
              }
            });
          }

          return Promise.resolve(Object.assign({}, projects[projectId]));
        });
      },
      resetProjectList: () => {
        projectList = [];
      },
      resetProjectById: (projectId) => {
        projects[projectId.toString()] = null;
      },
      resetAll: () => {
        projectList = [];
        projects = {};
      },
      setProjectById: (projectId, updatedProj) => {
        const clonedProject = Object.assign({}, updatedProj);
        projects[projectId] = clonedProject;
        const projectIdx = projectList.findIndex((p) => p._id === projectId);
        if (projectIdx > -1) {
          projectList[projectIdx] = clonedProject;
        } else {
          projectList.push(clonedProject);
        }

        $rootScope.$broadcast('projectUpdate-' + projectId, updatedProj);
        sg2ProjectService.set(clonedProject);
      },
      getManagedProjectsByUserId: (userId, projectRoles) =>
        dataService.getProjectList()
          .then((allProjects) => {
            const filteredProjects = allProjects.filter((proj) => {
              if (!projectRoles.includes('admin')) {
                const hasUser = proj.users.some((user) =>
                  user.userId._id === userId && projectRoles.includes(user.projectRole));
                return hasUser && !proj.archived;
              }
              return !proj.archived;
            });
            return Promise.resolve(filteredProjects);
          })
          .catch(Promise.reject)
    };

    $rootScope.$on('loggedOut', () => {
      dataService.resetAll();
    });

    return dataService;
  }
})();
